// src/hooks/usePermission.js
import { useState, useEffect } from 'react';
import sessionService from '../services/SessionService';
import userService from '../services/UserService';

// Returns permission info for the current logged-in user in a given module.
// moduleName: 'GeoRisk' | 'CustomerRisk' | 'BWRA' | 'Admin' | 'Dashboard'
const usePermission = (moduleName) => {
  const getPerms = () => {
    const session = sessionService.getSession();
    const email = session?.username;
    if (!email) return { canView: false, canEdit: false, canAdmin: false, role: 'viewer' };
    const canEdit = userService.hasPermission(email, moduleName, 'edit');
    const canAdmin = userService.hasPermission(email, moduleName, 'admin');
    const role = userService.getEffectiveRole(email);
    return { canView: true, canEdit, canAdmin, role };
  };

  const [perms, setPerms] = useState(getPerms);

  useEffect(() => {
    return userService.subscribe(() => setPerms(getPerms()));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return perms;
};

export default usePermission;
